import { render, staticRenderFns } from "./UsualSuppliers.vue?vue&type=template&id=edee8e02&scoped=true&lang=pug&"
import script from "./UsualSuppliers.vue?vue&type=script&lang=ts&"
export * from "./UsualSuppliers.vue?vue&type=script&lang=ts&"
import style0 from "./UsualSuppliers.vue?vue&type=style&index=0&id=edee8e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edee8e02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
